import jrpc20WSClient from "./jrpc20WSClient";
import employee from "./employee";

// I metodi del magazzino alimentare sono esposti sull'endpoint warehouse
// (stesse credenziali, stesso token: employeeportaltoken e' condivisa).
class foodWarehouse {
    wsClient = new jrpc20WSClient(process.env.REACT_APP_BACKEND_WS_URL_WAREHOUSE, process.env.REACT_APP_BACKEND_WS_USR, process.env.REACT_APP_BACKEND_WS_PWD)

    getOrders() {
        let employee_obj = new employee();
        return new Promise((resolve, reject) => {
            let post_data = {
                user_data: { token: employee_obj.token },
                call_data: {}
            };

            this.wsClient.request('post', 'warehouse/foodWarehouse/wsGetOrders', post_data).then((result) => {
                resolve(result.call_data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    getPickingList(data) {
        let employee_obj = new employee();
        return new Promise((resolve, reject) => {
            let post_data = {
                user_data: { token: employee_obj.token },
                call_data: { order_uuid: data.order_uuid }
            };

            this.wsClient.request('post', 'warehouse/foodWarehouse/wsGetPickingList', post_data).then((result) => {
                resolve(result.call_data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    savePicking(data) {
        let employee_obj = new employee();
        return new Promise((resolve, reject) => {
            let post_data = {
                user_data: { token: employee_obj.token },
                call_data: {
                    order_uuid: data.order_uuid,
                    rows: data.rows
                }
            };

            this.wsClient.request('post', 'warehouse/foodWarehouse/wsSavePicking', post_data).then((result) => {
                resolve(result.call_data);
            }).catch((error) => {
                reject(error);
            });
        });
    }
}

export default foodWarehouse;
